import { NgIf } from '@angular/common';
import { Component, DestroyRef, Input, OnChanges, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { CasinoLobbyService, ConfigProviderService, NewsFeedV2Service } from '@casinocore/platform/core';
import { TrackingService } from '@frontend/vanilla/core';
import { Subscription } from 'rxjs';

import { NewsFeedV2ContainerComponent } from '../news-feed-v2-container/news-feed-v2-container.component';

@Component({
    selector: 'cc-news-feed-v2-on-lobbytype',
    templateUrl: 'news-feed-v2-on-lobbytype.component.html',
    imports: [NgIf, NewsFeedV2ContainerComponent],
})
export class NewsFeedV2OnLobbyTypeComponent implements OnInit, OnDestroy, OnChanges {
    @Input() lobbyType: string;
    @Input() categoryRoute: string;
    @Input() data: any;
    newsFeedObj: any;
    newsFeedData: Subscription;
    newsFeedResponse: any = [];
    raisedTrackingEventOnLoadOnce: boolean;
    liveNewsfeed: any;
    newsFeedAttributes: any;
    private destroyRef = inject(DestroyRef);
    constructor(
        private casinoLobbyService: CasinoLobbyService,
        private newsFeedV2Service: NewsFeedV2Service,
        private tracking: TrackingService,
        private configProviderService: ConfigProviderService,
    ) {}

    ngOnInit() {
        this.newsFeedData = this.newsFeedV2Service.newsFeedV2Observable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((_response: any) => {
            if (_response) {
                const newsFeedPath: string = this.getNewsFeedPath();
                if (_response.get(newsFeedPath)) {
                    this.bindNewsFeed();
                }
            }
        });
    }
    ngOnChanges() {
        this.bindNewsFeed();
    }
    getNewsFeedPath(): string {
        const category: any = this.casinoLobbyService.getCategoryInfo(this.lobbyType, this.categoryRoute);
        if (
            category &&
            category.categoryInfo &&
            category.categoryInfo.sitecoreData.newsFeedContainer &&
            category.categoryInfo.sitecoreData.newsFeedContainer.length > 0
        ) {
            const newsfeedpath: string = category.categoryInfo.sitecoreData.newsFeedContainer[0].path;
            return newsfeedpath;
        }
        return '';
    }
    bindNewsFeed() {
        const newsfeedpath: string = this.getNewsFeedPath();
        const newsFeedConfig = this.configProviderService.provideNewsFeedCasinoConfig();
        if (newsFeedConfig && newsFeedConfig.isEnabled) {
            if (newsfeedpath) {
                this.newsFeedObj = this.newsFeedV2Service.getNewsFeedMap(newsfeedpath);
                this.setNewsFeedData(this.newsFeedObj);
                if (this.newsFeedObj) {
                    this.newsFeedResponse = this.newsFeedObj.newsFeedObjList;
                    this.newsFeedAttributes = this.newsFeedObj.attributes;
                    if (this.newsFeedResponse && this.newsFeedResponse.length > 0) {
                        this.createNewsFeedResponseArray(this.newsFeedResponse);
                    }
                } else {
                    this.newsFeedResponse = [];
                    this.newsFeedAttributes = null;
                }
            } else {
                this.newsFeedResponse = [];
                this.newsFeedAttributes = null;
            }
        }
    }
    setNewsFeedData(newsFeedResponse: any) {
        if (newsFeedResponse) {
            this.postDataFetched();
        }
    }
    postDataFetched() {
        if (this.newsFeedResponse) {
            if (!this.raisedTrackingEventOnLoadOnce) {
                this.tracking.triggerEvent('Event.Clicks', {
                    'component.CategoryEvent': 'NewsFeed',
                    'component.LabelEvent': 'NewsFeed_Load',
                    'component.ActionEvent': 'Load',
                    'component.PositionEvent': 'not applicable',
                    'component.LocationEvent': this.data ? this.data.trackPos : '',
                    'component.EventDetails': 'NewsFeed_Load',
                    'component.URLClicked': 'not applicable',
                });
                this.raisedTrackingEventOnLoadOnce = !this.raisedTrackingEventOnLoadOnce;
            }
        }
    }
    createNewsFeedResponseArray(newsFeedResponse: any) {
        this.newsFeedResponse = this.newsFeedV2Service.setNewsFeedResponseArray(newsFeedResponse);
    }
    ngOnDestroy() {
        if (this.newsFeedData) {
            this.newsFeedData.unsubscribe();
        }
    }
}
